import _objectWithoutProperties from "/Users/oct16/work/Cat/timecat-issue-helper/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { MDXTag } from '@mdx-js/tag';
export default (function (_ref) {
  var components = _ref.components,
      props = _objectWithoutProperties(_ref, ["components"]);

  return /*#__PURE__*/React.createElement(MDXTag, {
    name: "wrapper",
    components: components
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, "\u7B80\u6D01\u6E05\u6670\u7684\u91CD\u73B0\u6B65\u9AA4\u80FD\u591F\u5E2E\u52A9\u6211\u4EEC\u66F4\u8FC5\u901F\u5730\u5B9A\u4F4D\u95EE\u9898\u6240\u5728\u3002\u652F\u6301\u4F7F\u7528 ", /*#__PURE__*/React.createElement("a", {
    href: "https://guides.github.com/features/mastering-markdown/",
    target: "_blank"
  }, "Markdown"), " \u6765\u683C\u5F0F\u5316\u5217\u8868\u6216\u662F\u4EE3\u7801\u7247\u6BB5\u3002"));
});